













import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { IPortalUser } from "../../models/interfaces/authentication/portal-user.model.interface";
import { IUserRoleUpdate } from "../../models/interfaces/authentication/user-role-update.model.interface";
import { State, Getter, Action, namespace } from "vuex-class";
import { IRole } from "../../models/interfaces/authentication/role.model.interface";
import SuccessMessage from "@/components/SuccessMessage.vue";

const UserModule = namespace("userManagementModule");

@Component({
    components: {
        SuccessMessage
    }
})
export default class UserRoleDropdown extends Vue {
    @UserModule.Getter public roles;
    @UserModule.Getter public user;
    @UserModule.Action public retrieveRoles;
    @UserModule.Action public setUserRole;

    @Provide() public userModel: IPortalUser;

    @Provide() public currentRole: number | null = null;

    @Provide() public options = [];

    private lastSaved: Date | null = null;

    public created() {
        this.setCurrentUser(this.user);
        this.retrieveRoles().then((result) => {
            this.options = this.roles.map((val) => ({
                value: val.id,
                text: val.name
            }));
        });
    }

    get getUser() {
        return this.user;
    }

    @Watch("getUser")
    public onUserChanged(val: IPortalUser | null, oldVal: IPortalUser | null) {
        this.setCurrentUser(val);
    }

    public setCurrentUser(val: IPortalUser | null) {
        if (val) {
            this.userModel = val;

            if (val.role) {
                this.currentRole = val.role.id;
            }
        }
    }

    private updateRole() {
        if (this.currentRole) {
            const model: IUserRoleUpdate = {
                userId: this.getUser.id,
                roleId: this.currentRole
            };

            this.setUserRole(model).then((result) => {
                if (result) {
                    this.lastSaved = new Date();
                }
            });
        }
    }
}
